var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2401_4152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.43381 9.18373L6.84615 14.5961C7.47665 15.2266 8.49877 15.2266 9.12927 14.5961C9.75977 13.9656 9.75977 12.9429 9.12927 12.3124L7.48423 10.6674C18.5256 10.1241 25.7054 17.5351 25.772 25.1315C25.7741 25.4061 26.1598 25.4619 26.2454 25.2095C28.9115 17.3125 24.0625 7.39406 11.3891 5.6006C10.1617 5.44081 8.92019 5.31948 7.66894 5.23173L9.12981 3.77085C9.76031 3.14035 9.76031 2.11768 9.12981 1.48773C8.49931 0.857227 7.47719 0.856685 6.84669 1.48773L1.43381 6.9006C0.803312 7.53056 0.803312 8.55323 1.43381 9.18373Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2401_4152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.960938 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconLeft);
export default __webpack_public_path__ + "static/media/share-icon-left.615900aacc19aca7817a8c9b2efc5e79.svg";
export { ForwardRef as ReactComponent };